import { component } from "picoapp";
import $ from "jquery";
import "slick-carousel";

export default component((node, ctx) => {
  const slider = node.querySelector(".js-items");

  if (slider) {
    $(".js-items").not(".slick-initialized").slick({
      dots: false,
      arrows: false,
      draggable: true,
      swipe: true,
      infinite: false,
    });
  }
});
